import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesPackageCreateMain } from './modules/ui/Main';

const PackageCreatePage = (
  <SuspensePage>
    <PagesPackageCreateMain />
  </SuspensePage>
);

export default PackageCreatePage;
